/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-bitwise */

import React, { useEffect, useMemo } from 'react';
import { Layout } from 'antd';

import { useSystemConfig, useRouterStatus } from '#/store';
import userInfo from '#/util/userInfo';
import { env } from '#/util/env';

import AccoutSelect from '#/component/AccountSelect';
import IconFont from '#/component/IconFont';
import UserInfo from '../../../common/UserInfoPop';
import Menu from './components/Menu';

import './index.scss';

const { Header } = Layout;

const SPECIAL_PATH = {
  HOME: '/',
  BILL: '/billing-payments',
  BILL_DETAIL: '/payment-billing',
};
const AdsHeader = () => {
  const [{ curTopPageConfig }] = useSystemConfig();
  const [{ ActiveConfig }] = useRouterStatus();
  const curPath = ActiveConfig?.fullPath || null;
  const bindSubAccount = userInfo.getBindSubAccount();
  const subAccountId = userInfo.getSubAccountId();

  const isBillPage = curPath === SPECIAL_PATH.BILL || curPath === SPECIAL_PATH.BILL_DETAIL;
  const isHomePage = curPath === SPECIAL_PATH.HOME;

  const bindSubAccountOpt = useMemo(
    () =>
      bindSubAccount.map((item) => ({
        value: item.subAccountId,
        label: item.subAccountName,
        accountId: item.oldAcountId,
        zone: item.zone,
        primaryAccountId: item.primaryAccountId,
      })),
    [bindSubAccount],
  );

  const { category } = curTopPageConfig.layout || {};

  useEffect(() => {
    window.advertiserOpt = [];
    window.agencyOpt = [];
    window.accountOpt = [];
    userInfo.getBindSubAccount().forEach((item) => {
      window.advertiserOpt.push({
        label: item.subAccountName,
        value: item.subAccountId,
      });
      // 主账户只能有一个
      !window.agencyOpt.length &&
        window.agencyOpt.push({
          label: item.primaryAccountName,
          value: item.primaryAccountId,
        });
      window.accountOpt.push({
        accountId: item.oldAcountId,
        advId: item.subAccountId,
        agcyId: item.primaryAccountId,
      });
    });
  }, []);

  useEffect(() => {
    const subAccount = bindSubAccount.find((item) => item.subAccountId === subAccountId);
    if (subAccount) {
      window.timeZone = subAccount.zone;
    }
  }, [subAccountId]);

  function handleAccountChange(_val) {
    userInfo.confirmCurAccount(_val);
    window.location.reload();
  }

  return (
    <Header className="ads-layout-main-header" id="mainHeader">
      <section className="ads-layout-header-wrap">
        <div className="ads-layout-header-left">
          <a
            href="/"
            style={{ cursor: 'pointer' }}
            className={`logo-box ${env !== 'product' ? 'is-test-environment' : ''}`}
          >
            <i className="main-icon" />
          </a>
          {isBillPage ? (
            <div className="ads-bill-tag">
              <i />
              <div className="ffpb">Billing&Payments</div>
            </div>
          ) : null}
          {category ? <Menu category={category} /> : null}
        </div>

        {/* 用户 && 账户信息部分 */}
        <div className="ads-layout-header-right">
          {!isBillPage ? (
            <div className="account-info">
              {!isHomePage ? (
                <>
                  <AccoutSelect
                    primaryAccountName={bindSubAccount?.[0]?.primaryAccountName}
                    value={subAccountId}
                    options={bindSubAccountOpt}
                    onChange={handleAccountChange}
                  />
                  <div
                    onClick={() => {
                      // window.location.href = '/';
                      window.router.go('/');
                    }}
                    className="ads-header-home cp"
                  >
                    <IconFont type="icon-Home" />
                  </div>
                </>
              ) : null}
            </div>
          ) : null}

          <UserInfo />
        </div>
      </section>
    </Header>
  );
};
export default AdsHeader;
